import React, { useState } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { CSVLink } from 'react-csv';
import styles from './styles';

const SelectedOffers = ({
  classes, selectedItems, updateItem, removeItem,
}) => {
  const preprocessSelectedItems = items =>
    items.map(item => ({
      ...item,
      Price: item.Price === -1 ? 0 : item.Price, // Replace -1 with 0 for Price
    }));

  // Preprocess the selectedItems to replace -1 Price with 0
  const preprocessedItems = preprocessSelectedItems(selectedItems);

  const [discount, setDiscount] = useState(0);

  const calculateTotal = () =>
    preprocessedItems.reduce(
      (total, item) => total + (item.Units * (item.Terms || 1) * item.Price),
      0,
    );

  const calculateDiscountedTotal = () =>
    parseFloat((calculateTotal() * (1 - (discount / 100))).toFixed(2));

  const csvHeaders = [
    { label: 'SKU', key: 'SKU' },
    { label: 'Description', key: 'Description' },
    { label: 'Units', key: 'Units' },
    { label: 'Terms', key: 'Terms' },
    { label: 'Price', key: 'Price' },
    { label: 'Total', key: 'Total' },
  ];

  const csvData = [
    ...preprocessedItems.map(item => ({
      SKU: item.SKU,
      Description: item.Description,
      Units: item.Units,
      Terms: item.Terms || 1,
      Price: item.Price,
      Total: item.Units * (item.Terms || 1) * item.Price,
    })),
    {
      SKU: '',
      Description: '',
      Units: '',
      Terms: '',
      Price: '',
      Total: '',
    },
    {
      SKU: '',
      Description: 'Total List Cost',
      Units: '',
      Terms: '',
      Price: '',
      Total: calculateTotal(),
    },
    {
      SKU: '',
      Description: 'Discount (%)',
      Units: '',
      Terms: '',
      Price: '',
      Total: `${discount}%`,
    },
    {
      SKU: '',
      Description: 'Total Contract Cost',
      Units: '',
      Terms: '',
      Price: '',
      Total: calculateDiscountedTotal(),
    },
  ];

  return (
    <div className={classes.selectedOffers}>
      <h3>Selected Offers</h3>
      <div className={classes.tableContainer}>
        <div className={classes.selectedOffersTableWrapper}>
          <table className={classes.selectedOffersTable}>
            <thead>
              <tr>
                <th className={classes.th}>SKU</th>
                <th className={classes.th}>Description</th>
                <th className={classes.th}>Units</th>
                <th className={classes.th}>Terms</th>
                <th className={classes.th}>Price</th>
                <th className={classes.th}>Total</th>
                <th className={classes.th} />
              </tr>
            </thead>
            <tbody>
              {preprocessedItems.map((item) => {
                const uniqueKey = `${item.type}_${item.SKU}_${item.Description}`;
                return (
                  <tr key={uniqueKey}>
                    <td className={classes.td}>{item.SKU}</td>
                    <td className={classes.td}>{item.Description}</td>
                    <td className={classes.td}>
                      <input
                        type="number"
                        value={item.Units}
                        onChange={e =>
                          updateItem(uniqueKey, { Units: parseInt(e.target.value, 10) })
                        }
                        className={classes.input}
                      />
                    </td>
                    <td className={classes.td}>
                      <input
                        type="number"
                        value={item.Terms || 1}
                        onChange={e =>
                          updateItem(uniqueKey, { Terms: parseInt(e.target.value, 10) })
                        }
                        className={classes.input}
                      />
                    </td>
                    <td className={classes.td}>{item.Price === -1 ? 0 : item.Price}</td>
                    <td className={classes.td}>{item.Units * item.Price}</td>
                    <td className={classes.td}>
                      <button onClick={() => removeItem(uniqueKey)} className={classes.removeBtn}>
                        X
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className={classes.totals}>
          <div className={classes.totalSection}>
            <div className={classes.totalSectionMultiLine}>
              <span>Total List Cost</span>
              <span className={classes.spanSmall}>(includes Terms)</span>
            </div>
            <span>{calculateTotal()}</span>
          </div>

          <div className={classes.totalSection}>
            <span>Discount</span>
            <div className={classes.discountInputWrapper}>
              <input
                type="number"
                value={discount}
                step="5"
                onChange={(e) => {
                  const value = Math.max(0, Math.min(100, parseFloat(e.target.value) || 0));
                  setDiscount(value);
                }}
                className={classes.input}
              />
              <span>%</span>
            </div>
          </div>

          <div className={classes.totalSection}>
            <span>Total Contract Cost</span>
            <span>{calculateDiscountedTotal()}</span>
          </div>
        </div>
      </div>
      <div className={classes.disclaimer}>
        While prices are to date, discounting is for illustrative purposes only. Approval rules still apply.
      </div>
      {preprocessedItems.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <CSVLink
            data={csvData}
            headers={csvHeaders}
            filename="selected_offers.csv"
            className={classes.btnFilled}
          >
            Export
          </CSVLink>
        </div>
      )}
    </div>
  );
};

SelectedOffers.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedItems: PropTypes.array.isRequired,
  updateItem: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
};

export default injectSheet(styles)(SelectedOffers);
